import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-tour-complete-dialog',
  templateUrl: './tour-complete-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TourCompleteDialogComponent {
  @Output() takeTour = new EventEmitter<any>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, isVisited: boolean }[]) { }
}
